import { render, staticRenderFns } from "./ClientSettingFixedPhraseEdit.vue?vue&type=template&id=1c0f548e&scoped=true&"
import script from "./ClientSettingFixedPhraseEdit.vue?vue&type=script&lang=js&"
export * from "./ClientSettingFixedPhraseEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClientSettingFixedPhraseEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClientSettingFixedPhraseEdit.vue?vue&type=style&index=1&id=1c0f548e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f548e",
  null
  
)

export default component.exports